package com.narbase.letsgo.web.utils

import com.narbase.letsgo.web.common.TimeFormats
import com.narbase.letsgo.web.storage.StorageManager
import kotlin.js.Date

/**
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2020] Narbase Technologies
 * All Rights Reserved.
 * Created by Mohammad Abbas
 * On: 3/25/20.
 */

fun Date.toHoursAndMinutes(): String { //10:30
    val options = dateLocaleOptions { hour = "2-digit"; minute = "2-digit"; this.asDynamic().hourCycle = "h12" }
    return toLocaleTimeString("en-US", options)
}

fun Date.toMonthAndDay(): String { // Jan 20
    return TimeFormats.monthAndDay(this)
}
fun Date.formatDateAndTime() = "${toMonthAndDay()} ${toHoursAndMinutes()}"

fun Date.toDayAndLongMonth(): String { // 20 Jan
    val options = dateLocaleOptions { day = "numeric"; month = "long"; }
    return toLocaleDateString(StorageManager.language.locale, options)
}

fun Date.toYearMonthDay(): String { //12 Nov 2019
    val options = dateLocaleOptions { day = "numeric"; month = "short"; year = "numeric"; }
    return toLocaleDateString(StorageManager.language.locale, options)
}

fun Date.toYearLongMonthDay(): String { //12 November 2019
    val options = dateLocaleOptions { day = "numeric"; month = "long"; year = "numeric"; }
    return toLocaleDateString(StorageManager.language.locale, options)
}

fun Date.toNumericMonthDayYear(): String { //12/1/2019
    val options = dateLocaleOptions { day = "numeric"; month = "numeric"; year = "numeric"; }
    return toLocaleDateString(StorageManager.language.locale, options)
}

fun Date.toShortMonthAndYear(): String { // Jan 2020
    val options = dateLocaleOptions { month = "short"; year = "numeric"; }
    return toLocaleDateString(StorageManager.language.locale, options)
}

fun Date.formatToDateInputElement(): String {
    fun pad(value: Int) = value.toString().padStart(2, '0')

    return "${getFullYear()}-${pad(getMonth() + 1)}-${pad(getDate())}"
}